import { RichTextEditor } from "@mantine/tiptap";
import { useEditor } from "@tiptap/react";
import { Document } from "@tiptap/extension-document";
import { Paragraph } from "@tiptap/extension-paragraph";
import { Text as TiptapText } from "@tiptap/extension-text";
import { Bold } from "@tiptap/extension-bold";
import { Italic } from "@tiptap/extension-italic";
import Underline from "@tiptap/extension-underline";
import { HardBreak } from "@tiptap/extension-hard-break";
import { History } from "@tiptap/extension-history";
import { Text } from "@mantine/core";
import { useEffect } from "react";
import styles from "./SessionDescriptionEditor.module.css";

const SessionDescriptionEditor = ({ content = null, onChange, error }) => {
  const editor = useEditor({
    shouldRerenderOnTransaction: true,
    extensions: [
      Document,
      Paragraph,
      TiptapText,
      Bold,
      Italic,
      Underline,
      HardBreak,
      History,
    ],
    content,
    onUpdate({ editor }) {
      onChange(editor.getJSON());
    },
  });
  useEffect(() => {
    if (
      editor &&
      !editor.isDestroyed &&
      content !== undefined &&
      JSON.stringify(editor.getJSON()) !== JSON.stringify(content)
    ) {
      editor.commands.setContent(content || "");
    }
  }, [editor, content]);

  return (
    <div className={styles.editorWrapper}>
      <RichTextEditor
        editor={editor}
        mt="md"
        style={{ border: error && "1px solid red" }}
        variant="subtle"
      >
        <RichTextEditor.Toolbar sticky stickyOffset={60}>
          <RichTextEditor.ControlsGroup>
            <RichTextEditor.Bold />
            <RichTextEditor.Italic />
            <RichTextEditor.Underline />
            <RichTextEditor.ClearFormatting />
          </RichTextEditor.ControlsGroup>
        </RichTextEditor.Toolbar>
        <RichTextEditor.Content />
        {error && (
          <Text size="sm" c="red">
            {error.message}
          </Text>
        )}
      </RichTextEditor>
    </div>
  );
};

export default SessionDescriptionEditor;
